import React, { Component } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { connect } from "react-redux";
import {getPvpCard,getDistinctColumnValues,runSimulation,updateUserQuery,setPvpLibraryMessage,updateEntityColumnValues,clearEntityColumnValues} from "../../actions/pvp-library.actions";
import {Button,Dropdown,Loader,Icon,Label,Popup,Segment,DropdownItemProps,Form,Menu,Input,Message,Divider,Sidebar,Image} from "semantic-ui-react";
import { CONFIG } from "../../helper/config";
import "./pvp-card.css";
import _ from "lodash";
import { storeSessionId } from "../../actions/view.actions";
import { IMAGECONFIG } from "../../helper/image-config";

interface IProps {
  is_license_expire: boolean;
  getPvpCard: (arg0: any, auth_token: string, query_id: any) => void;
  getDistinctColumnValues: (arg0: any, arg1: string, query_id: any,arg3:any) => void;
  runSimulation: (arg0: any, arg1: string) => void;
  updateEntityColumnValues:(arg0: any, arg1: any) => void;
  clearEntityColumnValues:(arg0:any)=>void;
  updateUserQuery: (arg0: any, arg1: string, arg2: any) => void;
  setPvpLibraryMessage: (msg: string) => void;
  storeSessionId:(arg0: string) => void;
  pvp_card: any;
  query: any;
  corrected_query_json: any;
  columns_list: any[];
  column_alias: any[];
  pvp_library_msg: string;
  base_scenario_filter_column: any;
  entity_column_values:any;
  sessionId:string;
}

interface IState {
  team_context: any;
  port_no: any;
  token: any;
  show_filter_label_tooltip: any;
  user_query: any;
  entities: any[];
  filtered_values: any[];
  query_id: any;
  base_scenario_column: any;
  notes_popup_visible: boolean;
  search_value:any;
}

class PvpCards extends Component<IProps, IState> {
  timer: any = null;
  constructor(props: IProps) {
    super(props);
    this.state = {
      team_context: {},
      port_no: "",
      token: "",
      show_filter_label_tooltip: "",
      user_query: "",
      entities: [],
      filtered_values: [],
      query_id: "",
      base_scenario_column: {},
      notes_popup_visible: false,
      search_value:'',
    };
  }

  /**
   * Called when the component has been mounted.
   * Handles the logic for both Teams and WebApp.
   * For Teams:
   * - Initializes the Microsoft Teams app.
   * - Gets the context (channel, team, user, etc.).
   * - Gets the auth token.
   * - Calls the getPvpCard action with the context and token.
   * - Sets the component state.
   * For WebApp:
   * - Listens for the message event.
   * - Parses the query parameters.
   * - Calls the getPvpCard action with the context and token.
   * - Sets the component state.
   */
  componentDidMount() {
    microsoftTeams.app.initialize();
    microsoftTeams.app.notifySuccess();
    const query_params = window.location.search.split("?")[1];
    const query_id = query_params
      ? query_params.split(CONFIG.URLQUERYPARAMSEPERATOR)[0].split("=")[1]
      : "";
    let team_context: any = {};
    microsoftTeams.app.getContext().then((context) => {
      console.log("context", context);

      team_context.user_id = context.user?.id;
      team_context.user_name = context.user?.userPrincipalName;
      team_context.tenant_id = context.user?.tenant?.id;
      team_context.teams_channel_id = context.channel?.id;
      team_context.channelId = "msteams";

      microsoftTeams.authentication.getAuthToken().then((token: string) => {
          let info = {
            ...team_context,
          };
          if(!this.props.sessionId){
            let session_id = new Date().toString();
              this.props.storeSessionId(session_id)
            }
          this.props.getPvpCard(info, token, query_id);

          this.setState({
            team_context: team_context,
            token: token,
            query_id,
          })
        }).catch((error) => {
          console.log("Failed to get token: ", error);
        })
        
      })
      

     this.setState({
      user_query: this.props.query,
      entities: this.props.corrected_query_json.entities,
      base_scenario_column: JSON.parse(
        JSON.stringify(this.props.base_scenario_filter_column)
      ),
    });
  }

  /**
   * Called when the component has been updated.
   * Checks if the pvp_card prop has changed.
   * If it has, updates the state with the new pvp_card data.
   */
  componentDidUpdate(prevProps: IProps, prevState: IState) {
    let { pvp_card, query, corrected_query_json, base_scenario_filter_column } =
      this.props;
    if (!_.isEqual(prevProps.pvp_card, pvp_card)) {
      this.setState({
        user_query: query,
        entities: corrected_query_json.entities,
        base_scenario_column: JSON.parse(
          JSON.stringify(base_scenario_filter_column)
        ),
      });
    }
  }

  /**
   * Renders the query input and channel dropdown.
   * The query input allows the user to modify the query.
   * The channel dropdown allows the user to select a channel.
   * The modify button updates the query.
   */
  renderQuery = () => {
    let { pvp_card, base_scenario_filter_column } = this.props;
    let { user_query, base_scenario_column } = this.state;
    let screen_width=window.screen.width;
    return (
      <div style={{ display: "flex", gap: screen_width >CONFIG.PVP.MOBILEWIDTH?"20px":"10px", flexWrap: "wrap" }}>
        <div className="query">
          <div className="query-div" style={{fontWeight:'bolder'}}>{CONFIG.PVP.QUERY}</div>
          <Input data-testid="query-input"
            value={user_query}
            className="query-input"
            onChange={(e) => this.handleQueryChange(e)}
          />
        </div>
        <div className="channel">
          <label style={{fontWeight:'bolder'}}>{`${base_scenario_filter_column.name} : `}</label>
          <Dropdown
            selection
            icon={'chevron down'}
            className="channel-dropdown"
            options={this.channelOptions()}
            value={base_scenario_column.default_value}
            onChange={(e) => this.handleChannelChange(e)}
          />
        </div>
        {screen_width<=CONFIG.PVP.MOBILEWIDTH?this.renderCorrectedQuery():null}
        <Menu secondary className="sticky-bottom">
          <Menu.Menu className="update-button">
            <Button
              primary
              content={"Modify"}
              onClick={() => this.updateQuery()}
              disabled={
                pvp_card.query === user_query &&
                base_scenario_filter_column.default_value ===
                  base_scenario_column.default_value
              }
            />
          </Menu.Menu>
        </Menu>
      </div>
    );
  };

  /**
   * Handles the change in the channel dropdown.
   * Updates the base_scenario_column default value with the selected channel.
   */
  handleChannelChange = (e) => {
    let { base_scenario_column } = this.state;
    base_scenario_column.default_value = e.target.innerText;
    this.setState({ base_scenario_column });
  };

  /**
   * Handles the change in the query input.
   * Updates the user_query state with the new query.
   */
  handleQueryChange = (e) => {
    this.setState({ user_query: e.target.value });
  };

  /**
   * Renders the message if there is a pvp_library_msg.
   * The message is displayed for 4 seconds before disappearing.
   */
  renderMessage = () => {
    let { pvp_library_msg } = this.props;
    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (pvp_library_msg !== undefined && pvp_library_msg.trim() !== "") {
      this.timer = setTimeout(() => {
        this.props.setPvpLibraryMessage("");
      }, 4000);

      return (
        <div id="narrative-board-message-container" style={{ width: "60%" }}>
          <Message
            error
            content={pvp_library_msg}
            onDismiss={() => this.props.setPvpLibraryMessage("")}
          />
        </div>
      );
    } else {
      return null;
    }
  };

  /**
   * Renders the channel options for the dropdown.
   * The options are generated from the base_scenario_filter_column values.
   */
  channelOptions = () => {
    let { base_scenario_filter_column } = this.props;
    let data = base_scenario_filter_column.values;
    let options: DropdownItemProps[] = [];
    options = data?.map((op, i) => {
      return {
        key: i,
        text: op,
        value: op,
      };
    });
    return options;
  };

  /**
   * Renders the corrected query.
   * The corrected query is displayed in a div with the highlighted query.
   */
  renderCorrectedQuery = () => {
    let { pvp_card } = this.props;

    return (
      <div className="correct-query">
        <div style={{ fontWeight: "bold", lineHeight: "24px" }}>
          {CONFIG.PVP.CORRECTEDQUERY}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: pvp_card.highlighted_query }}
          className="correct_query"
        />
      </div>
    );
  };

  /**
   * Updates the query with the selected channel and user query.
   * Calls the updateUserQuery action with the updated query data.
   */
  updateQuery = () => {
    let { token, team_context, user_query, base_scenario_column } = this.state;
    let { pvp_card } = this.props;
    let query_data = {
      query: user_query,
      base_scenario: "base_scenario",
      base_scenario_classification_column_value:
        base_scenario_column.default_value,
      ...team_context,
    };
    this.props.updateUserQuery(query_data, token, pvp_card.request_id);
    this.props.clearEntityColumnValues([])
  };

  /**
   * Renders the unit options for the dropdown.
   * The options are generated from the CONFIG.PVP.UNITOPTIONS.
   */
  unitOptions = () => {
    let data = CONFIG.PVP.UNITOPTIONS;
    let options: DropdownItemProps[] = [];
    options = data.map((op, i) => {
      return {
        key: i,
        text: op,
        value: op,
      };
    });
    return options;
  };

  /**
   * Renders the applied filters for the dropdown.
   * The options are generated from the entity_column_values.
   */
  getAppliedFilter = (col, index) => {
    let { entities } = this.state;
    let applied_filter;
    applied_filter =
      entities[index]?.applied_filters[`${col}`]?.length > 0
        ? entities[index].applied_filters[`${col}`]
        : [];
    return applied_filter;
  };

  /**
   * Handles the selection of a value in the dropdown.
   * Updates the applied filters for the selected column and entity index.
   */
  selectvalue = (event, filter_column, option, entity_index) => {
    let { entities } = this.state;
    if (entities[entity_index].applied_filters[filter_column] === undefined) {
      entities[entity_index].applied_filters[filter_column] = [];
    }
    if (
      entities[entity_index].applied_filters[filter_column].includes(option)
    ) {
      let op_index =
        entities[entity_index].applied_filters[filter_column].indexOf(option);
      entities[entity_index].applied_filters[filter_column].splice(op_index, 1);
    } else {
      entities[entity_index].applied_filters[filter_column] = [
        ...entities[entity_index].applied_filters[filter_column],
        option,
      ];
    }
    this.props.updateEntityColumnValues(filter_column,entity_index)
    this.setState({ entities });
  };

  /**
   * Sets the options for the multiple dropdown.
   * The options are generated from the entity_column_values.
   */
  setMultipleDropdownOptions = (column, entity_index) => {
    let { entity_column_values } = this.props;
    let { entities, show_filter_label_tooltip } = this.state;
    let options: DropdownItemProps[] = [];
    let screen_width=window.screen.width;
    let filter_obj={};
    let is_loader=true;
    if( entity_column_values?.[entity_index]){
      filter_obj=entity_column_values[entity_index]
    }
    let filter_search_values = filter_obj[column];
    if(filter_search_values && filter_search_values.length>0){
      is_loader=false
    }
    let data = filter_search_values ?? [];

    options = data?.map((op, i) => {
      return {
        key: i,
        text: op,
        value: op,
        onClick: (event, data) => {
          this.selectvalue(event, column, op, entity_index);
        },
        content: (
          <Popup
            trigger={
              <Label
                content={
                  <div className="multiple-dropdown-options add-ellipsis-to-text">
                    {op}
                  </div>
                }
                onMouseOver={(e) => screen_width > CONFIG.PVP.MOBILEWIDTH ? this.isPopUpEnabled(e, op):null}
                onTouchStart={(e) => this.isPopUpEnabled(e, op)}
                onMouseLeave={this.disablePopup}
                onTouchEnd={this.disablePopup}
                className="dropdowm-item-label add-ellipsis-to-text"
                icon={
                  entities[entity_index]?.applied_filters[column]?.includes(op)
                    ? "check square outline"
                    : "square outline"
                }
              />
            }
            content={op}
            open={
              show_filter_label_tooltip !== null &&
              show_filter_label_tooltip !== "" &&
              show_filter_label_tooltip === op
            }
          />
        ),
      };
    });
    if (options.length > 0) {
      options.unshift({
        selected: true,
        key: "Select all",
        text: "Select all",
        value: "Select all",
        onClick: (event) =>
          this.selectAllValues(event, data, column, entity_index),
        content: (
          <Label
            content={"Select all"}
            className="select-all dropdowm-item-label add-ellipsis-to-text"
            icon={
              entities[entity_index]?.applied_filters[column]?.length ===
              filter_obj[column]?.length ? (
                  <Icon.Group>
                    <Icon name="check square outline" />
                  </Icon.Group>

              ) : (
                <Icon name="square outline" />
              )
            }
          />
        ),
      });
    } else if(filter_obj[column] ===undefined && is_loader) {
      let loader = <Loader key='loader' active inline="centered" />;

      options.push(loader);
    }

    return options;
  };

  /**
   * Handles the selection of all values in the dropdown.
   * Updates the applied filters for the selected column and entity index.
   */
  selectAllValues = (event, data, filter_column, entity_index) => {
    let { entity_column_values } = this.props;
    let { entities } = this.state;
    let filter_obj={};
    if( entity_column_values?.[entity_index]){
      filter_obj=entity_column_values[entity_index]
    }
    if (entities[entity_index].applied_filters[filter_column] === undefined) {
      entities[entity_index].applied_filters[filter_column] = [];
    }
    if (
      entities[entity_index].applied_filters[filter_column].length !==
      filter_obj[filter_column].length
    ) {
      entities[entity_index].applied_filters[filter_column] =
        filter_obj[filter_column].slice(0);
    } else {
      entities[entity_index].applied_filters[filter_column] = [];
    }
    this.props.updateEntityColumnValues(filter_column,entity_index)
    this.setState({ entities });
  };

  isPopUpEnabled = (event, element: string) => {
    let target_elem = event.target;
    let elem_width = target_elem.getBoundingClientRect().width;
    if (Math.ceil(elem_width) < target_elem.scrollWidth) {
      this.setState({ show_filter_label_tooltip: element });
    }
  };

  disablePopup = () => {
    if (this.state.show_filter_label_tooltip !== "") {
      this.setState({ show_filter_label_tooltip: "" });
    }
  };

  /**
   * Renders the dropdowns for the filters.
   * The dropdowns are generated from the columns_list and entity_column_values.
   */
  renderDropdowns = (index) => {
    let data = this.props.columns_list;
    const column_names=this.props.column_alias;
    let dropdowns: JSX.Element[] = [];

    data?.map((value, i) => {
      let drpdwn_element = (
        <Form.Dropdown
          key={`filter-${value}`}
          id={
            this.getAppliedFilter(data[i], index).length > 0
              ? "teams-color"
              : "multiple"
          }
          className={
            this.props.pvp_card.column_width[value] === 30
              ? "multiple-dropdown-three-field"
              : "multiple-dropdown-two-field"
          }
          label={this.getDropdownLabel(column_names[i]?column_names[i]:data[i], index,data[i])}
          search
          selection
          selectOnNavigation={false}
          selectOnBlur={false}
          closeOnChange={false}
          onSearchChange={(e)=>this.setSearchValue(e)}
          placeholder="Select Filter"
          onFocus={(e) => this.getColumnValues(data[i],index)}
          text={
            this.getAppliedFilter(data[i], index)?.length > 0
              ? this.getAppliedFilter(data[i], index).join(",")
              : ["Select Filter"]
          }
          options={this.setMultipleDropdownOptions(data[i], index)}
          onKeyDown={(event: any) => 
            event.key === 'Enter' ? this.updateSelectedItem(event,data[i],index) : null
            }
        />
      );
      dropdowns.push(drpdwn_element);
    });

    return dropdowns;
  };

  setSearchValue=(e:any)=>{
    console.log(e.target.value)
    this.setState({search_value:e.target.value})
  }

  /**
   * Updates the selected item in the dropdown.
   * Filters the values based on the search input.
   */
  updateSelectedItem = (event,col,entity_index) => {
    let { search_value,entities } = this.state;
    let { entity_column_values } = this.props;
    if (String(search_value).trim() !== '') {
      const reg_ex = new RegExp(
        _.escapeRegExp(String(search_value).trim()),
        'i'
      );
      
      let filtered_values =entity_column_values[entity_index][col]?.filter((c_value) => {
        return reg_ex.test(c_value);
      });
      if(entities[entity_index]!==undefined && entities[entity_index].applied_filters[col] !==undefined){
        entities[entity_index].applied_filters[col]=[...entities[entity_index].applied_filters[col],...filtered_values]
        entities[entity_index].applied_filters[col]=entities[entity_index].applied_filters[col].filter((val,i)=>entities[entity_index].applied_filters[col].indexOf(val)===i)
        this.props.updateEntityColumnValues(col,entity_index)
      this.setState({entities})
      }else if(entities[entity_index]!==undefined){
        entities[entity_index].applied_filters[col]=[...filtered_values]
        this.props.updateEntityColumnValues(col,entity_index)
      this.setState({entities})
      }
  
    }
  };

  /**
   * Gets the distinct column values for the selected column.
   * Calls the getDistinctColumnValues action with the team_context, token, and query_id.
   */
  getColumnValues = (column,entity_index) => {
    let { entity_column_values } = this.props;
    let { team_context, query_id, token,entities } = this.state;
    if (entity_column_values?.length!==0 && entity_column_values[entity_index] !== undefined && entity_column_values[entity_index].column !== undefined) {
      return;
    } else {
      let filters_applied={};
      for(let col in entities[entity_index].applied_filters){
        if(col!==column){
          filters_applied[col]=entities[entity_index].applied_filters[col]
        }
      }
      let info = {
        ...team_context,
        column_name: column,
        applied_filters:filters_applied
      };
      this.props.getDistinctColumnValues(info, token, query_id,entity_index);
    }
  };

  /**
   * Clears the individual filter for the selected column and entity index.
   * Updates the applied filters for the selected column and entity index.
   */
  clearIndivisualFilter = (current_filter_column,entity_index) => {
    let {pvp_card}=this.props;
    let {entities}=this.state;
    pvp_card.columns_list.map((column) => {
      if (column === current_filter_column) {
         entities[entity_index].applied_filters[column]=[]
      } 
    });
    this.props.updateEntityColumnValues(current_filter_column,entity_index)
     this.setState({ entities });
  };

  /**
   * Renders the label for the dropdown.
   * The label includes the filter name and a clear button.
   */
  getDropdownLabel = (label, entity_index,filter_column) => {
    let filter_label = label;
    const {entities}=this.state;
    console.log(entities[entity_index]?.applied_filters[filter_column])
    return (
      <div
        className="filter-label-header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Popup
          className="filter-label-tooltip"
          position="bottom center"
          on="click"
          hoverable
          basic
          content={filter_label}
          open={false}
          trigger={<div className="label-name"> {filter_label}</div>}
        />
                <small>
          <button
            className="clear-filter"
            onClick={() => {
              this.clearIndivisualFilter(filter_column,entity_index);
            }}
            onKeyDown={() => {
              this.clearIndivisualFilter(filter_column,entity_index);
            }}
          >
            { entities[entity_index]?.applied_filters[filter_column] !==undefined &&
              entities[entity_index]?.applied_filters[filter_column]?.length !== 0
              ? 'Clear'
              : ''}
          </button>
        </small>
      </div>
    );
  };

  /**
   * Renders the PVP card entities.
   * The entities are displayed with action buttons, input fields, and dropdowns.
   */
  renderPvpCardEntities = () => {
    let { entities } = this.state;
    console.log("entities :: ",entities)
    return entities?.map((entity, i) => (
        <div className="entities" key={entity}>
          <div className="action-value">
            <Image
              src={IMAGECONFIG.GREENINCREASE}
              className="add-icon"
              onClick={() => this.changeActionValue("increase", i)}
            />
            <Input
              value={entity.value}
              className={entity.value >= 0 ? "green" : "red"}
              onChange={(e) => this.handleValueChange(e, i)}
            />
            <Image
              src={IMAGECONFIG.REDDECREASE}
              className="add-icon"
              onClick={() => this.changeActionValue("decrease", i)}
            />
            <Dropdown
              selection
              id="unit-dropdown"
              icon={'chevron down'}
              options={this.unitOptions()}
              placeholder="Select Unit"
              value={entity.unit}
              onChange={(e) => this.handleUnitDropdownChange(e, i)}
            />
          </div>
          <div className="filter-popup">{this.renderDropdowns(i)}</div>
        </div>
    ));
  };

  /**
   * Renders the value change for the input field.
   * Updates the value for the selected entity index.
   */
  handleValueChange = (event, index) => {
    let { entities } = this.state;
    if (!isNaN(event?.target.value)) {
      entities[index].value = event?.target.value;
      this.setState({ entities });
    }
  };

  /**
   * Changes the action value for the selected entity index.
   * Increases or decreases the value based on the action.
   */
  changeActionValue = (action, index) => {
    let { entities } = this.state;
    if (action === "increase") {
      entities[index].value = +entities[index].value + 1;
    } else {
      entities[index].value = +entities[index].value - 1;
    }
    this.setState({ entities });
  };

  /**
   * Renders the notes section.
   * The notes are displayed in a sidebar that can be toggled.
   */
  renderNotes = () => {
    let { notes_popup_visible } = this.state;
    let screen_width=window.screen.width;
    let bottomValue = "0";

    if (notes_popup_visible) {
      if (screen_width > (CONFIG.PVP.MOBILEWIDTH + 60)) {
        bottomValue = "98px";
      } else {
        bottomValue = "148px";
      }
    }
    return (
      <div
        className="notes-div"
        style={{
          marginTop: notes_popup_visible ? "-100px" : "0px",
          bottom: bottomValue,
          transition:'.5s ease'
        }}
      >
        <Button
          onClick={() =>
            this.setState({ notes_popup_visible: !notes_popup_visible })
          }
          className="notes-btn"
        >
          Notes
          <Icon
            name={notes_popup_visible ? "caret down" : "caret up"}
            style={{ margin: "2px" }}
          />
        </Button>
        <Sidebar
          className="notes-sidebar"
          animation={"overlay"}
          direction={"bottom"}
          visible={notes_popup_visible}
        >
          <div className="notes">
            <div>{CONFIG.PVP.NOTES.FIRSTNOTE}</div>
            <div>{CONFIG.PVP.NOTES.SECONDNOTE}</div>
            <div>{CONFIG.PVP.NOTES.THIRDNOTE}</div>
          </div>
        </Sidebar>
      </div>
    );
  };

  /**
   * Submits the PVP data for simulation.
   * Updates the entities with the applied filters and submits the data.
   */
  submitPvpData = () => {
    let { entities, token, team_context } = this.state;
    let { pvp_card,entity_column_values } = this.props;
    let simulation_data = JSON.parse(JSON.stringify(pvp_card));
    let filter_obj={};
    entities.map((entity, i) => {
      if( entity_column_values?.[i]){
        filter_obj=entity_column_values[i]
      }
      if (Object.keys(entity.applied_filters).length > 0) {
        for (let col in entity.applied_filters) {
          if (
            entity.applied_filters[col]?.length === filter_obj[col]?.length ||
            entity.applied_filters[col]?.length === 0
          ) {
            delete entity.applied_filters[col];
          }
        }
      }
    });
    simulation_data.corrected_query_json.entities = entities;
    simulation_data.tenant_id = team_context.tenant_id;
    this.props.runSimulation(simulation_data, token);
  };

  /**
   * Handles the change in the unit dropdown.
   * Updates the unit for the selected entity index.
   */
  handleUnitDropdownChange = (event, index) => {
    let { entities } = this.state;
    entities[index].unit = event.target.innerText;
    this.setState({ entities });
  };

  /**
   * Renders the PVP card component.
   * Displays the license expiration message, query input, channel dropdown, and PVP card entities.
   */
  render() {
    const { is_license_expire, pvp_card } = this.props;
    let screen_width=window.screen.width;
    if (is_license_expire) {
      return (
        <Segment
          placeholder
          textAlign="center"
          size="large"
          content={CONFIG.LICENSE_EXPIRE}
        />
      );
    } else if (Object.keys(pvp_card).length > 0) {
        return (
          <>
            {this.renderMessage()}
            {this.renderQuery()}
            {screen_width>CONFIG.PVP.MOBILEWIDTH?this.renderCorrectedQuery():null}
            <Divider section />
            <div className="pvp-card-entities">
              {this.renderPvpCardEntities()}
              <Menu secondary attached="bottom">
                <Menu.Menu position="right" className="submit-button">
                  <Button
                    primary
                    content={CONFIG.BUTTONTEXT.RUNSIMULATION}
                    disabled={!pvp_card.allow_run_simulation}
                    onClick={() => this.submitPvpData()}
                  />
                </Menu.Menu>
              </Menu>
            </div>
            {this.renderNotes()}
          </>
        );
      } else {
        return this.renderMessage();
    }
  }
}

/**
 * Maps state to props for the PvpCard component.
 * Retrieves the pvp_card, query, corrected_query_json, columns_list, column_alias, base_scenario_filter_column, filter_obj, pvp_library_msg, entity_column_values, and sessionId from the state.
 * @param {Object} state - The state of the application.
 * @returns {Object} A props object containing the pvp_card, query, corrected_query_json, columns_list, column_alias, base_scenario_filter_column, filter_obj, pvp_library_msg, entity_column_values, and sessionId.
 */
const mapStateToProps = (state: any) => {
  const { filter_obj, pvp_card, pvp_library_msg,entity_column_values } = state.pvpLibraryState;
  const {sessionId} = state.viewState;
  return {
    pvp_card,
    query: pvp_card.query ? pvp_card.query : "",
    corrected_query_json: pvp_card.corrected_query_json
      ? JSON.parse(JSON.stringify(pvp_card.corrected_query_json))
      : {},
    columns_list: pvp_card.columns_list ? pvp_card.columns_list : [],
    column_alias:pvp_card.column_alias ? pvp_card.column_alias :[],
    base_scenario_filter_column:
      pvp_card?.base_scenario_classification_column_json
        ? pvp_card.base_scenario_classification_column_json
        : {},
    filter_obj,
    pvp_library_msg,
    entity_column_values,
    sessionId
  };
};

export default connect(mapStateToProps, {
  getPvpCard,
  getDistinctColumnValues,
  runSimulation,
  updateUserQuery,
  setPvpLibraryMessage,
  updateEntityColumnValues,
  clearEntityColumnValues,
  storeSessionId
})(PvpCards);
